import React from 'react';
export var PropsContext = /*#__PURE__*/React.createContext({});
export var PropsContextConsumer = PropsContext.Consumer;
export function usePropsFromContext(name) {
  var context = React.useContext(PropsContext);
  if (context[name] === undefined) {
    return {};
  }
  return context[name];
}
export function PropsContextProvider(_ref) {
  var {
    children,
    props
  } = _ref;
  return /*#__PURE__*/React.createElement(PropsContext.Provider, {
    value: props
  }, children);
}
PropsContextProvider.displayName = 'PropsContextProvider';
//# sourceMappingURL=index.js.map